import React from 'react';

import ErrorMessage from 'common/ErrorMessage';
import ModernModal from 'common/modals/ModernModal';
import SpinnerV2 from 'common/SpinnerV2';
import ButtonV2 from 'common/ui/ButtonV2';
import { P } from 'common/ui/Text';
import styles from 'css-module/components/subdomain/admin/AdminQueue/GettingStarted/_SourceFiltersModal.module.scss';

import type { Integration } from 'common/subdomain/admin/AdminQueue/GettingStarted/constants';

export type Props = {
  onClose: () => void;
  integration: Integration;
  enableIntegrationSync: (integration: Integration) => void;
  onSubmit: () => Promise<void>;
  sourceFilter: React.ReactNode;
  saving: boolean;
  loading?: boolean;
  error?: boolean;
  disabled?: boolean;
};

const SourceFiltersModal = ({
  saving,
  onClose,
  integration,
  onSubmit,
  sourceFilter,
  loading,
  error,
  disabled,
}: Props) => {
  return (
    <ModernModal
      modalClassName={styles.modal}
      sectionsClassName={styles.modalSections}
      header={<div className={styles.modalHeaderText}>Enable {integration.label}</div>}
      onClose={onClose}
      sections={[
        <>
          <P className={styles.filterDescription} variant="bodyMd">
            Autopilot will process conversations based on these settings.
          </P>
          {loading && <SpinnerV2 size="large" />}
          {error && (
            <ErrorMessage>
              Something went wrong fetching options, please contact support.
            </ErrorMessage>
          )}
          {!loading && !error && sourceFilter}
        </>,
      ]}
      footer={
        <div className={styles.footer}>
          <div className={styles.connected}>
            <div className={styles.connectedDot} />
            <P className={styles.connectedText} variant="bodySm">
              {integration.label} connected
            </P>
          </div>
          <div className={styles.footerButtons}>
            <ButtonV2 variant="outlined" size="medium" onClick={onClose}>
              Cancel
            </ButtonV2>
            <ButtonV2
              disabled={saving || disabled}
              variant="contained"
              loading={saving}
              size="medium"
              onClick={onSubmit}>
              Submit
            </ButtonV2>
          </div>
        </div>
      }
    />
  );
};

export default SourceFiltersModal;
